import { CheckSmallIcon, MinusSmallIcon, XSmallIcon } from '@zep-us/zus-icons';
import { LoadingSpinner } from '@/shared/components';
import { cn } from '@/utils/tailwind.util';
import { type AiBuilderProgressMessageStatus, type AiBuilderProgressStep } from '../store';
const PROGRESS_STEP_TEXT_CLASS: Record<AiBuilderProgressStep['status'], string> = {
  done: 'text-alternative',
  running: 'text-disabled',
  pending: 'text-disabled',
  stopped: 'text-disabled'
};
const PROGRESS_STEP_TEXT_SIZE_CLASS: Record<AiBuilderProgressMessageStatus, string> = {
  running: 'text-body-md-semibold',
  complete: 'text-body-sm-semibold',
  stopped: 'text-body-sm-semibold'
};
export const AiBuilderProgressStepList = ({
  id,
  status,
  steps
}: {
  id: string;
  status: AiBuilderProgressMessageStatus;
  steps: AiBuilderProgressStep[];
}) => {
  return <div id={id} className="flex flex-col items-start px-md" data-sentry-component="AiBuilderProgressStepList" data-sentry-source-file="AiBuilderProgressStepList.tsx">
      <div className="flex flex-col items-start border-l border-alternative">
        {steps.map(step => <ProgressStep key={step.id} messageStatus={status} step={step} />)}
      </div>
    </div>;
};
const ProgressStep = ({
  messageStatus,
  step
}: {
  messageStatus: AiBuilderProgressMessageStatus;
  step: AiBuilderProgressStep;
}) => {
  const stepStatus = getProgressStepDisplayStatus(step.status, messageStatus);
  return <div className={cn('flex min-h-[32px] min-w-[36px] items-center justify-center overflow-hidden rounded-full', PROGRESS_STEP_TEXT_SIZE_CLASS[messageStatus], PROGRESS_STEP_TEXT_CLASS[stepStatus])} data-sentry-component="ProgressStep" data-sentry-source-file="AiBuilderProgressStepList.tsx">
      <div className="flex items-center justify-center gap-3xs px-sm py-2xs">
        <ProgressStepIndicator status={stepStatus} data-sentry-element="ProgressStepIndicator" data-sentry-source-file="AiBuilderProgressStepList.tsx" />
        <span className="whitespace-nowrap text-center">{step.label}</span>
      </div>
    </div>;
};
const getProgressStepDisplayStatus = (stepStatus: AiBuilderProgressStep['status'], messageStatus: AiBuilderProgressMessageStatus): AiBuilderProgressStep['status'] => {
  if (messageStatus === 'complete') return 'done';
  if (messageStatus === 'stopped' && stepStatus !== 'done') return 'stopped';
  return stepStatus;
};
const ProgressStepIndicator = ({
  status
}: {
  status: AiBuilderProgressStep['status'];
}) => {
  return <span className="flex size-md shrink-0 items-center justify-center" data-sentry-component="ProgressStepIndicator" data-sentry-source-file="AiBuilderProgressStepList.tsx">
      {getIcon(status)}
    </span>;
};
const getIcon = (status: AiBuilderProgressStep['status']) => {
  switch (status) {
    case 'done':
      return <CheckSmallIcon size="xs" fill="currentColor" />;
    case 'running':
      return <LoadingSpinner className="size-md text-current motion-reduce:animate-none" />;
    case 'pending':
      return <MinusSmallIcon size="xs" fill="currentColor" />;
    case 'stopped':
      return <XSmallIcon size="xs" fill="currentColor" />;
  }
};